import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";

import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Process from "@/pages/Process";
import Properties from "@/pages/Properties";
import PropertyPublicDetail from "@/pages/PropertyPublicDetail";
import BeforeAfter from "@/pages/BeforeAfter";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import Sell from "@/pages/Sell";
import Investors from "@/pages/Investors";
import WorkWithUs from "@/pages/WorkWithUs";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";

import AdminLayout from "@/components/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import SearchEngine from "@/pages/admin/SearchEngine";
import SavedSearches from "@/pages/admin/SavedSearches";
import NewFinds from "@/pages/admin/NewFinds";
import SourceManager from "@/pages/admin/SourceManager";
import DataPipelines from "@/pages/admin/DataPipelines";
import Watchlist from "@/pages/admin/Watchlist";
import PropertyDatabase from "@/pages/admin/PropertyDatabase";
import PropertyAdminDetail from "@/pages/admin/PropertyAdminDetail";
import DealPipeline from "@/pages/admin/DealPipeline";
import Calculator from "@/pages/admin/Calculator";
import Projects from "@/pages/admin/Projects";
import Portfolio from "@/pages/admin/Portfolio";
import RefurbLibrary from "@/pages/admin/RefurbLibrary";
import Team from "@/pages/admin/Team";
import CaseStudiesAdmin from "@/pages/admin/CaseStudiesAdmin";
import LeadsAdmin from "@/pages/admin/LeadsAdmin";
import TasksAdmin from "@/pages/admin/TasksAdmin";
import NotesAdmin from "@/pages/admin/NotesAdmin";
import MediaAdmin from "@/pages/admin/MediaAdmin";
import Reports from "@/pages/admin/Reports";
import WebsiteCMSAdmin from "@/pages/admin/WebsiteCMSAdmin";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" toastOptions={{ style: { background: "#121212", border: "1px solid #262626", color: "#FDFBF7" } }} />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/process" element={<Process />} />
            <Route path="/properties" element={<Properties />} />
            <Route path="/properties/:id" element={<PropertyPublicDetail />} />
            <Route path="/before-after" element={<BeforeAfter />} />
            <Route path="/before-after/:id" element={<CaseStudyDetail />} />
            <Route path="/sell" element={<Sell />} />
            <Route path="/investors" element={<Investors />} />
            <Route path="/work-with-us" element={<WorkWithUs />} />
            <Route path="/contact" element={<Contact />} />
          </Route>

          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="search-engine" element={<SearchEngine />} />
            <Route path="saved-searches" element={<SavedSearches />} />
            <Route path="new-finds" element={<NewFinds />} />
            <Route path="sources" element={<SourceManager />} />
            <Route path="pipelines" element={<DataPipelines />} />
            <Route path="watchlist" element={<Watchlist />} />
            <Route path="properties" element={<PropertyDatabase />} />
            <Route path="properties/:id" element={<PropertyAdminDetail />} />
            <Route path="pipeline" element={<DealPipeline />} />
            <Route path="calculator" element={<Calculator />} />
            <Route path="projects" element={<Projects />} />
            <Route path="portfolio" element={<Portfolio />} />
            <Route path="refurb-library" element={<RefurbLibrary />} />
            <Route path="team" element={<Team />} />
            <Route path="case-studies" element={<CaseStudiesAdmin />} />
            <Route path="leads" element={<LeadsAdmin />} />
            <Route path="tasks" element={<TasksAdmin />} />
            <Route path="notes" element={<NotesAdmin />} />
            <Route path="media" element={<MediaAdmin />} />
            <Route path="reports" element={<Reports />} />
            <Route path="cms" element={<WebsiteCMSAdmin />} />
            <Route path="settings" element={<SettingsAdmin />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
